import styled, { css } from 'styled-components';
import {
    spaceMixin,
    mediaMixin,
    token,
} from '@zillow/constellation';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background-color: ${token('colors.white')};
    padding: ${spaceMixin('xs')} 0;
    ${mediaMixin('lg', css`
        padding: 12px 0;
    `)};
`;

export const StyledStepContainer = styled.div`
    flex: 1;
    position: relative;
    padding: 0 ${spaceMixin('md')};
`;
